export const PAGE_PER_SIZE = 4; // 한 페이지에 보여질 게시물 수
export const NAV_ITEM_SIZE = 5; // 보여질 버튼의 개수
export const CHECK_PASSWORD =
  /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
export const CHECK_EMAIL =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
